import React, { useState, useEffect } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { BsEyeFill } from 'react-icons/bs';
import axios from 'axios';

export default function TablaDocumentos({ vehicleDetails }) {
    const [sortedDocuments, setSortedDocuments] = useState([]);
    const [approvalState, setApprovalState] = useState([]);
    const [numDocumentosValidados, setNumDocumentosValidados] = useState(0);

    useEffect(() => {
        if (vehicleDetails && vehicleDetails.docs && Array.isArray(vehicleDetails.docs)) {
            const sortedDocs = [...vehicleDetails.docs].sort((a, b) => {
                if (a.data && b.data && typeof a.data.index === 'number' && typeof b.data.index === 'number') {
                    return a.data.index - b.data.index;
                }
                return 0;
            });
            setSortedDocuments(sortedDocs);

            const initialApproval = sortedDocs.map((doc) => doc.validation === "check");
            setApprovalState(initialApproval);

            const numValidados = initialApproval.filter((value) => value).length;
            setNumDocumentosValidados(numValidados);
        }
    }, [vehicleDetails]);

    const toggleValidation = async (newValidation) => {
        try {
            if (vehicleDetails && vehicleDetails.id) {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_MUTATION_DOCVERIFICATION}${vehicleDetails.id}/${newValidation}`,
                    null,
                    {
                        headers: {
                            "x-hasura-admin-secret": process.env.REACT_APP_API_KEY,
                        },
                    }
                );
                const numValidados = approvalState.filter((value) => value).length;
                setNumDocumentosValidados(numValidados);
                if (response.status === 200) {
                    vehicleDetails.docVerification = newValidation === "true";
                } else {
                    console.error('Error al cambiar el estado de validación en Hasura:', response);
                }
            } else {
                console.error('El objeto vehicleDetails o su propiedad id es nulo.');
            }
        } catch (error) {
            console.error('Error al cambiar el estado de validación en Hasura:', error);
        }
    };
    const isButtonDisabled = vehicleDetails && vehicleDetails.docs && 
    !vehicleDetails.docs.every(doc => doc.validation === "check");
  

    const toggleApproval = async (index) => {
        const doc = sortedDocuments[index];

        try {
            const newApprovalValue = doc.validation === "check" ? "false" : "check";
            const response = await axios.post(
                `${process.env.REACT_APP_GRAPHQL_ENDPOINT}${newApprovalValue}/${vehicleDetails.id}/${doc.docid}`,
                null,
                {
                    headers: {
                        "x-hasura-admin-secret": process.env.REACT_APP_API_KEY,
                    },
                }
            );

            if (response.status === 200) {
                doc.validation = newApprovalValue;

                setSortedDocuments((prevState) => {
                    const newState = [...prevState];
                    newState[index] = doc;
                    return newState;
                });

                setApprovalState((prevState) => {
                    const newState = [...prevState];
                    newState[index] = newApprovalValue === "check";
                    return newState;
                });
            } else {
                console.error('Error al cambiar el estado en Hasura:', response);
            }
        } catch (error) {
            console.error('Error al cambiar el estado en Hasura:', error);
        }
    };

    const openDocumentLink = (index) => {
        const documentSrc = sortedDocuments[index].src;
        window.open(documentSrc, '_blank', 'width=800,height=600');
    };

    return (
        <div className='mb-5 mr-7 ml-2'>
            <h2 className='text-center text-2xl font-bold rounded-l-2xl mb-2'>Documentos</h2>
            {sortedDocuments.length === 0 ? (
                <p>No hay documentos del conductor</p>
            ) : (
                sortedDocuments.map((document, index) => (
                    <div className='grid grid-cols-8 text-xl mb-1' key={index}>
                        <div className='col-span-6 text-2xl row-auto bg-orange-500 rounded-l-2xl text-center text-white px-2'>
                            <h1 className='mt-1 mb-1'>
                                {document.data ? (document.data.name || "N/A") : "N/A"}
                            </h1>
                        </div>
                        <div className='col-span-1 bg-green-500'>
                            <button className={`bg-${approvalState[index] ? 'green' : 'red'}-600 text-white w-full h-full flex items-center justify-center`}
                                onClick={() => toggleApproval(index)}>
                                {approvalState[index] ? (
                                    <FaCheck className='text-white' />
                                ) : (
                                    <FaTimes className='text-white bg-red-600' />
                                )}
                            </button>
                        </div>
                        <div className='col-span-1 bg-orange-500 rounded-r-2xl flex items-center ml-1 justify-center px-4'>
                            <button className='text-3xl' onClick={() => openDocumentLink(index)}>
                                <BsEyeFill />
                            </button>
                        </div>
                    </div>
                ))
            )}
            <button
                className={`p-2 text-white ml-6 mt-2 rounded-lg ${isButtonDisabled ? 'bg-gray-500 cursor-not-allowed' : 'bg-orange-500'}`}
                onClick={() => toggleValidation("true")}
                disabled={isButtonDisabled}
            >
                Validar documentos
            </button>
        </div>
    );
};